import { Box, Flex, Grid } from "@chakra-ui/react";
import { Icons, ToolTip, Typography } from "@reconvert/react-ui-component";
import { t } from "i18next";
import { useMemo } from "react";

const SVG_OBJ = {
  impressions: <div><Icons.Impression /></div>,
  click: <div><Icons.Clicks /></div>,
  declined: <div><Icons.DisLike /></div>,
  conversions: <div><Icons.Conversion /></div>,
  cvr: (
    <div>
      <svg width={20} height={20} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.83534 10.6613C6.01845 10.4587 6.14103 10.2154 6.20344 9.93247L6.21322 9.88814L6.17004 9.87413L5.41129 9.6281L5.35553 9.61002L5.34647 9.66794C5.30249 9.94909 5.18886 10.1529 5.00953 10.2863C4.8343 10.415 4.57836 10.4828 4.23499 10.4828C3.99589 10.4828 3.78544 10.4243 3.60204 10.3083C3.41884 10.1871 3.27296 10.0125 3.16512 9.78188C3.06259 9.55188 3.0103 9.27099 3.0103 8.93757C3.0103 8.60415 3.06259 8.32326 3.16512 8.09326C3.27297 7.86265 3.41877 7.69082 3.60163 7.57505L3.60163 7.57505L3.60194 7.57485C3.79035 7.45357 4.00838 7.39233 4.25775 7.39233C4.55943 7.39233 4.78716 7.45961 4.94733 7.58773L4.94732 7.58773L4.94788 7.58816C5.11244 7.71604 5.22694 7.92307 5.28615 8.21728L5.2979 8.27566L5.35337 8.25398L6.10453 7.96033L6.1456 7.94427L6.13481 7.90152C6.06226 7.61428 5.93736 7.37373 5.75902 7.1816C5.58656 6.99036 5.37257 6.84593 5.11805 6.7481C4.86852 6.65025 4.58654 6.60186 4.27293 6.60186C3.83074 6.60186 3.44495 6.69602 3.11739 6.88633C2.79488 7.07136 2.54306 7.34064 2.36195 7.69246L2.36183 7.69271C2.18549 8.0399 2.09844 8.45546 2.09844 8.93757C2.09844 9.41971 2.1855 9.83777 2.36169 10.1901L2.36183 10.1904C2.53793 10.5371 2.78721 10.8063 3.10938 10.9965L3.10993 10.9968C3.43234 11.1818 3.81049 11.2733 4.24258 11.2733C4.58135 11.2733 4.88594 11.2223 5.15558 11.1193M5.83534 10.6613C5.83526 10.6614 5.83517 10.6615 5.83509 10.6616L5.798 10.628L5.83557 10.661C5.83549 10.6611 5.83542 10.6612 5.83534 10.6613ZM5.83534 10.6613C5.65746 10.8637 5.43042 11.0162 5.15558 11.1193M5.15558 11.1193C5.15563 11.1192 5.15569 11.1192 5.15574 11.1192L5.1379 11.0725L5.15545 11.1193C5.15549 11.1193 5.15554 11.1193 5.15558 11.1193ZM10.5514 6.73286L10.5766 6.66535H10.5046H9.66992H9.63474L9.62286 6.69846L8.60614 9.53179L8.60607 9.53177L8.60527 9.53446L8.37645 10.3057L8.14728 9.52663L8.14736 9.52661L8.1464 9.52393L7.13727 6.69853L7.12542 6.66535H7.09019H6.22522H6.15303L6.17841 6.73293L7.84765 11.1774L7.85983 11.2098H7.89446H8.84289H8.87757L8.88972 11.1773L10.5514 6.73286ZM10.952 11.1598V11.2098H11.002H11.8063H11.8563V11.1598V9.47963H12.7154L13.7898 11.1864L13.8045 11.2098H13.8321H14.7199H14.8118L14.7618 11.1326L13.619 9.36764C13.7921 9.30703 13.9448 9.22162 14.0766 9.11088C14.3781 8.86184 14.5271 8.51344 14.5271 8.07249C14.5271 7.63669 14.378 7.29108 14.0768 7.04218C13.7819 6.78906 13.3823 6.66535 12.8837 6.66535H11.002H10.952V6.71535V11.1598ZM13.4278 7.59455L13.4278 7.59456L13.4286 7.59524C13.5554 7.69946 13.6228 7.86042 13.6228 8.08836C13.6228 8.31594 13.5556 8.48005 13.4282 8.58976C13.2992 8.69552 13.1003 8.75265 12.823 8.75265H11.8563V7.42408H12.823C13.1002 7.42408 13.2988 7.48379 13.4278 7.59455Z"
          fill="#363C45"
          stroke="#363C45"
          strokeWidth={0.1}
        />
        <path
          d="M8.4375 16.4375C12.5796 16.4375 15.9375 13.0796 15.9375 8.9375C15.9375 4.79536 12.5796 1.4375 8.4375 1.4375C4.29536 1.4375 0.9375 4.79536 0.9375 8.9375C0.9375 13.0796 4.29536 16.4375 8.4375 16.4375Z"
          stroke="#363C45"
        />
      </svg>
    </div>
  ),
};

type SvgKey = keyof typeof SVG_OBJ

const AnalyticsRow = ({
  name,
  type,
  value,
  change,
  isHighlighted,
  isForSidebar,
  variantStatus = true,
  iconSize,
  layout
}: {
  name: string;
  type?: string;
  value: string;
  change: string;
  isHighlighted?: boolean;
  isForSidebar?: boolean;
  variantStatus?: boolean;
  iconSize?: string;
  layout?: string
}) => {

  const formatChange = (change: string) => {
    if (change.length > 7) {
      return `${change.slice(0, 3)}...%`;
    }

    return change;
  };

  let svg = useMemo(() => {
    let key = type as SvgKey

    return SVG_OBJ[key]
  }, [type])

  return layout === "newLayout" ?
    <Grid
      alignItems="center"
      mx={isForSidebar ? "16px" : ""}
      gap={"4px"}
      fontSize={"12px"}
    >
      <Flex justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        gap={"4px"}>
        <ToolTip key={name} placement="top" label={t(name)} >
          {svg}
        </ToolTip>
        {value ? (
          <>
            <Typography
              id="value"
              fontWeight={isHighlighted ? "medium" : "normal"}
              variant="small"
              fontSize={"12px"}
              width={"fit-content"}
              color={variantStatus ? "neutrals.900" : "disable.color"}
            >
              {value}
            </Typography>
            <Typography
              id="changes"
              color={variantStatus ? (String(change)?.startsWith("-") ? `error.800` : `success.800`) : "disable.color"}
              variant="body"
              width={"fit-content"}
              whiteSpace={"nowrap"}
            >
              {String(change)?.startsWith("-") ? formatChange(String(change)) : `+${formatChange(String(change))}`}
            </Typography>
          </>
        ) : (
          <Flex justifyContent={"end"}>
            <Typography variant="small">-</Typography>
          </Flex>
        )}
      </Flex>
    </Grid> :
    <Grid
      templateColumns={isForSidebar ? "122px 70px min-content auto" : "auto min-content 20px 56px"}
      alignItems="center"
      mx={isForSidebar ? "16px" : ""}
      gap={"4px"}
    >
      <Box>
        <Typography
          id="name"
          fontWeight={isHighlighted ? "medium" : "normal"}
          variant="body"
          color={variantStatus ? "neutrals.900" : "disable.color"}
        >
          {name}
        </Typography>{" "}
      </Box>
      {value ? (
        <>
          <Flex justifyContent={isForSidebar ? "start" : "end"}>
            <Typography
              id="value"
              fontWeight={isHighlighted ? "medium" : "normal"}
              variant="body"
              width={"fit-content"}
              color={variantStatus ? "neutrals.900" : "disable.color"}
            >
              {value}
            </Typography>
          </Flex>
          <Flex alignItems={"center"}>
            {variantStatus ? (
              String(change)?.startsWith("-") ? (
                <Icons.AnalyticsArrowsDecrease size={iconSize} />
              ) : (
                <Icons.AnalyticsArrowsIncrease size={iconSize} />
              )
            ) : (
              <Icons.AnalyticsArrowsDisable isDecrease={String(change)?.startsWith("-")} />
            )}
          </Flex>
          <Box
            display={'flex'}
            flexDirection={'row-reverse'}
          >
            <Typography
              id="changes"
              color={variantStatus ? (String(change)?.startsWith("-") ? `error.800` : `success.800`) : "disable.color"}
              variant="body"
              width={"fit-content"}
              whiteSpace={"nowrap"}
            >
              {String(change)?.startsWith("-") ? formatChange(String(change)) : `+${formatChange(String(change))}`}
            </Typography>
          </Box>
        </>
      ) : (
        <Flex justifyContent={"end"}>
          <Typography variant="small">-</Typography>
        </Flex>
      )}
    </Grid>
};

export default AnalyticsRow;
